import api from '../config/api'

export type GcpProvisionedStatus = 'STOPPED' | 'STARTING' | 'RUNNING' | 'STOPPING' | 'AWAITING_INPUT' | null

export interface ProvisionedStatusResponse {
  status: GcpProvisionedStatus
  channel: string | null
}

const getProvisionedStatus = (cameraId: number) => {
  return api.get<ProvisionedStatusResponse>(`/management/cameras/${cameraId}/gcp/provisioned-status`)
}

const provision = (cameraId: number) => {
  return api.post(`/management/cameras/${cameraId}/gcp/provision`)
}

const deprovision = (cameraId: number) => {
  return api.delete(`/management/cameras/${cameraId}/gcp/provision`)
}

const startChannel = (cameraId: number) => {
  return api.post(`/management/cameras/${cameraId}/gcp/channel/start`)
}

const stopChannel = (cameraId: number) => {
  return api.post(`/management/cameras/${cameraId}/gcp/channel/stop`)
}

const CameraProvisionService = {
  getProvisionedStatus,
  provision,
  deprovision,
  startChannel,
  stopChannel,
}

export default CameraProvisionService
